import { render, staticRenderFns } from "./QRcodePage.vue?vue&type=template&id=35f9b5c3&scoped=true&"
import script from "./QRcodePage.vue?vue&type=script&lang=js&"
export * from "./QRcodePage.vue?vue&type=script&lang=js&"
import style0 from "./QRcodePage.vue?vue&type=style&index=0&id=35f9b5c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9b5c3",
  null
  
)

export default component.exports